export default "__VITE_ASSET__Aj9Pn7bg__"